document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-sticky-buy-bar]');
  if (!bar) return;

  var dataEl = bar.parentElement.querySelector('[data-sbb-data]');
  if (!dataEl) return;

  var triggers;
  try {
    triggers = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!triggers || !triggers.length) return;

  var imgEl = bar.querySelector('[data-sbb-img]');
  var eyebrowEl = bar.querySelector('[data-sbb-eyebrow]');
  var titleEl = bar.querySelector('[data-sbb-title]');
  var priceEl = bar.querySelector('[data-sbb-price]');
  var form = bar.querySelector('[data-sbb-form]');
  var variantInput = bar.querySelector('[data-sbb-variant]');
  var ctaLink = bar.querySelector('[data-sbb-cta-link]');

  var byWatch = {};
  triggers.forEach(function (t) {
    if (t.watch) byWatch[t.watch] = t;
  });

  var current = null;

  function render(trigger) {
    if (!trigger) {
      bar.classList.remove('is-visible');
      current = null;
      return;
    }
    if (trigger !== current) {
      current = trigger;
      eyebrowEl.textContent = trigger.eyebrow || '';
      titleEl.textContent = trigger.title || '';

      if (trigger.mode === 'product' && trigger.variantId) {
        if (trigger.image) {
          imgEl.src = trigger.image;
          imgEl.style.display = '';
        } else {
          imgEl.style.display = 'none';
        }
        priceEl.textContent = trigger.price || '';
        priceEl.style.display = '';
        variantInput.value = trigger.variantId;
        form.style.display = '';
        ctaLink.hidden = true;
      } else {
        imgEl.style.display = 'none';
        priceEl.style.display = 'none';
        form.style.display = 'none';
        ctaLink.hidden = false;
        ctaLink.href = trigger.url || '#';
        ctaLink.textContent = trigger.title || 'Scopri';
      }
    }
    bar.classList.add('is-visible');
  }

  var visible = [];

  function updateFromVisible() {
    if (visible.length) {
      render(byWatch[visible[visible.length - 1]]);
    } else {
      render(null);
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.getAttribute('data-sbb-watch');
        var idx = visible.indexOf(id);
        if (entry.isIntersecting) {
          if (idx === -1) visible.push(id);
        } else if (idx > -1) {
          visible.splice(idx, 1);
        }
      });
      updateFromVisible();
    },
    { rootMargin: '-42% 0px -42% 0px', threshold: 0 }
  );

  Object.keys(byWatch).forEach(function (watch) {
    var target = document.getElementById('shopify-section-' + watch);
    if (target) {
      target.setAttribute('data-sbb-watch', watch);
      observer.observe(target);
    }
  });
});
